import React, { useEffect, useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const ProductReport = ({ fromDate, toDate }) => {
  const { store } = useStateContext();

  const [data, setData] = useState();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
    const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

    const payload = {
      shopName: databaseStoreName,
      from: fromDate,
      to: toDate,
    };
    axiosClient
      .post("reports/sales/products", payload)
      .then((response) => setData(response.data.data))
      .catch((err) => console.log(err));
  }, [store, fromDate, toDate]);

  const formatDate = (dateString) => {
    const parts = dateString.split('-');
    if (parts.length === 3) {
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    } else {
        return 'Invalid Date';
    }
}

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="inherit">Product sales analysis</Typography>
        <Typography variant="caption">{` ${formatDate(fromDate)} - ${formatDate(toDate)}`}</Typography>
        <Divider />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={4}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Product</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Quantity</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Price</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      {data.map((product, index) => (
        <Grid item container xs={12} key={index+1}>
          <Grid item xs={4}>
            <Typography variant="body2" align="center">{product.name}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="center">{product.totalQuantity}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="center">{parseFloat(product.totalPrice).toFixed(2)}</Typography>
          </Grid>
          <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductReport;
